import Bowser from 'bowser-ultralight';
import memoizeOne from 'memoize-one';

import { getWindowObject } from '../utils/window-helper';

export const eventBrowserPlugin = memoizeOne(() => {
	if (!Bowser.getParser) {
		return null;
	}
	const browser = Bowser.getParser(getWindowObject()?.navigator?.userAgent || '');
	return {
		'event:browser:name': browser.getBrowserName(),
		'event:browser:version': browser.getBrowserVersion(),
	};
});
